export default function formatCurrency(value: string): string {

    if (!value) value = "0";

    value = value.toString().replace(/\D/g, '');

    value = (parseInt(value) / 100).toFixed(2).replace('.', ',');

    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    value = 'R$ ' + value;

    return value;
}